import { render, staticRenderFns } from "./FirmenlisteNewViva.vue?vue&type=template&id=87c56910"
import script from "./FirmenlisteNewViva.vue?vue&type=script&lang=js"
export * from "./FirmenlisteNewViva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports